export default __webpack_public_path__ + "static/media/quality.9b4fa11e.svg";